import React, {useState, useEffect} from "react";
import {Form, Row, Col, Input, Button, Collapse, Card, Table} from 'antd';
import jsonfile from './nation.json'
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import Config from "../../../../util/config";
import axios from '../../../../util/Api'
import moment from "moment";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import 'jspdf-autotable'
const Panel = Collapse.Panel;

const PerformanceComparison = () => {
    const ref = React.createRef();
    const formRef = React.createRef();

    const [state, setState] = useState([]);

    const [YEAR, setYear] = useState(moment().year());
    const [reqURL, setReqURL] = useState(jsonfile.urls.performancecomparison);

    const history = useHistory();
    const [form] = Form.useForm();

    const onFinish = values => {
        console.log('Received values of form: ', values);
        let wkd = "";
        let wk = "";
        let dt = "";
        const qs = Object.keys(values).map(key => {
                if (key === 'date') {
                    wk = formRef.current.getFieldValue('date');
                    const dt = CisUI().ParseDateFormat(values[key]);
                    return `${key}=${dt}`
                } else if (key === 'month') {
                    wk = formRef.current.getFieldValue('month');
                    // console.log("Selected Week : "+ wk);
                    wkd = CisUI().getMonthTitle(formRef.current.getFieldValue('month'));
                    return `${key}=${wkd[1]}`
                } else {
                    return `${key}=${values[key]}`
                }
            }
        ).join('&');

        const qsup = qs.replaceAll("undefined", "");
        //reqURL = reqURL+"/?"+qsup;
        history.push("?" + qsup);
        const newURL = Config.apiserver + jsonfile.urls.performancecomparison + "?" + qsup;
        console.log("NEURL :" + newURL);
        console.log("Month : " + wkd);
        const WKR = CisUI().ParseDateFormat(wk);
        const reportTitle = "Between " + CisUI().DateFormat(WKR[0]) + " and " + CisUI().DateFormat(WKR[1]);

        const url = Config.apiserver + jsonfile.urls.performancecomparison;
        //const data = SelectData(url);

        document.getElementById("loader").style.display = "block";
        axios.get(newURL)
            .then((res) => {
                console.log(res.data);
                document.getElementById("loader").style.display = "none";
                if (res.data.status === 1) {
                    //console.log("Response : "+ res.data);
                    const data = res.data;
                    setState(data.data)
                }
            })
            .catch((error) => {
                console.log(error);
                document.getElementById("loader").style.display = "none";
            });
    };


    let searchView = "";
    if (jsonfile.has_search) {
        searchView = <Card className="advance-search-card no-print">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']}>
                <Panel header="Advance Search" key="1">
                    <Form
                        key={5}
                        form={form}
                        ref={formRef}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch([], "", 1,"date",CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const print = () => {
        // window.print();
        window.open(Config.baseurl+"nationgrossreportprint.html?url="+window.btoa(state.reqURL)+"&filename=donation_gross&data=grossData&subtitle="+state.reportTitle+"&rptype=grossreport","_blank");
    }


    //for excel data
    const exportToExcel = (apiData, fileName) => {
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        //console.log("File type "+fileExtension);
        document.getElementById("rploader").style.display = "inline";
        const ws = XLSX.utils.json_to_sheet(apiData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        document.getElementById("rploader").style.display = "none";
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    const getAPIData = () => {
        axios.get(reqURL)
            .then((res) => {
                if(res.data.status === 1) {
                   setState(res.data.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
       getAPIData();
    }, []);





    const listAction = () =>
        (
            <div className="no-print">
                <button onClick={print} className="btn btn-export-print btn-circle-md" title="Print"><i
                    className="fas fa-print"/></button>
            </div>
        );

    const getExtra = (
        <>
            {listAction()}
        </>
    );


    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [4, 2]
    };

    return (
        <>
            {searchView}
            <Card id="reportview" extra={getExtra}>
                {CisUI().showLoading}
                <div ref={ref}>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h3>The Church of Pentecost U.S.A., Inc.</h3>
                            <h3>Performance Comparison Report</h3>
                            <h5>For the year of {YEAR}</h5>
                        </div>
                    </div>
                    <Collapse
                            style={{border: 'none'}}
                            accordion
                            expandIconPosition="right"
                            defaultActiveKey={['1']}>

                            <div className="table-responsive">

                                <table className="report2 table table-bordered">

                                    <thead>
                                    <tr>
                                        <th>Month</th>
                                        <th style={{textAlign: 'right'}}>Current Month Actual</th>
                                        <th style={{textAlign: 'right'}}>Last Month Actual</th>
                                        <th style={{textAlign: 'right'}}>Variance</th>
                                        <th style={{textAlign: 'right'}}>Budget (Current Month)</th>
                                        <th style={{textAlign: 'right'}}>Actual (Current Month)</th>
                                        <th style={{textAlign: 'right'}}>YTD Actual (Current Year)</th>
                                        <th style={{textAlign: 'right'}}>YTD Actual (Last year)</th>
                                        <th style={{textAlign: 'right'}}>YTD Budget</th>
                                        <th style={{textAlign: 'right'}}>YTD Variance</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        state.length > 0 ? <>
                                        {
                                            state.map((item, index) => {
                                                return <tr>
                                                    <th>{item.month}</th>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.currentMonthActual)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.lastMonthActual)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.variance)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.budgetCurrentMonth)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.actualCurrentMonth)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.ytdActualCurrentYear)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.ytdActualLastYear)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.ytdBudget)}</td>
                                                    <td style={{textAlign: 'right'}}>{CisUI().getCurrencyFormated1(item.ytdVariance)}</td>
                                                </tr>
                                            })
                                        }
                                        </> :<></>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </Collapse>

                </div>

            </Card>
        </>
    );
};

export default PerformanceComparison;